module.exports = __webpack_public_path__ + "static/media/snowflake.fc1aa3dd.png";